import { useState } from 'react';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import { DateRange } from '@components/shared/DateRange/types';
import { Timestamp__Output } from '@generated/grpc/google/protobuf/Timestamp';
import {
  CreateUnclearedVideoExportRequest__Output,
  TimestampWrapper__Output,
} from '@generated/grpc/spotify/s4mpview/v1';

const BEGINNING_OF_CLEARANCE = new Date('01/01/2024');

export const useUnclearedVideosExportRequest = () => {
  const [status, setStatus] = useState<FETCH_STATUS>(FETCH_STATUS.IDLE);

  const s4mpUnclearedExport = async (
    createCatalogExportDetails: CreateUnclearedVideoExportRequest__Output,
  ) => {
    setStatus(FETCH_STATUS.FETCHING);
    try {
      const res = await fetch('/catalog/api/unclearedvideosexportrequest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(createCatalogExportDetails),
      });
      setStatus(FETCH_STATUS.SUCCESS);
      if (!res.ok) {
        setStatus(FETCH_STATUS.ERROR);
        return false;
      }
      return res.ok;
    } catch (error) {
      setStatus(FETCH_STATUS.ERROR);
      return false;
    }
  };

  const parseDateRangeAsDateFilter = (dateRange: DateRange) => {
    let startSeconds: string = '0';
    let endSeconds: string = '0';
    if (dateRange?.startDate && dateRange?.endDate) {
      startSeconds = dateRange.startDate.unix().toString();
      endSeconds = dateRange.endDate.unix().toString();
    } else {
      endSeconds = new Date().valueOf().toString();
      startSeconds = new Date(BEGINNING_OF_CLEARANCE).valueOf().toString();
    }
    return {
      start: {
        timestamp: {
          seconds: startSeconds,
          nanos: 0,
        } as Timestamp__Output,
      } as TimestampWrapper__Output,
      end: {
        timestamp: {
          seconds: endSeconds,
          nanos: 0,
        } as Timestamp__Output,
      } as TimestampWrapper__Output,
    };
  };

  const parseLicensorIds = (licensors: string[]) => {
    return licensors.map(licensor => `spotify:licensor:${licensor}`);
  };

  return {
    status,
    actions: {
      s4mpUnclearedExport,
    },
    parseDateRangeAsDateFilter,
    parseLicensorIds,
  };
};
